import React, { Component, createElement } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import difference from 'lodash/difference'

import { confirmDialog } from 'primereact/confirmdialog';

import Header from '@components/Header';
import GeneralForm from '@components/Email/Form/General';
import LoadingAction from '@components/LoadingAction';

import { addEmail } from '@actions/emails'
import { sendActionToBitacora  } from '@actions/bitacora';

import { CLEAR_VALUES_EMAIL } from '@constants/actionType'

import store from '@store'

class NewEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      btnSubmitLoading: false
    };
  }

  async componentDidMount() {
    const {  history } = this.props

    if (history.location.state?.clearCache) {
      await store.dispatch({
        type: CLEAR_VALUES_EMAIL,
      })
    }

    return this.setState({loadingPage: false})
  }

  newEmail = async (justification) => {
    const { history, t, addEmail, _general, sendActionToBitacora } = this.props
    this.setState({ btnSubmitLoading: true });
      const response = await addEmail()
      if (!response.status) {
        const dataBitacora = {
          transactionName: 'actPlantillaCorreo',
          reason: `${_general.nombre} || ${justification}`,
        }
        await sendActionToBitacora(dataBitacora)
        this.setState({ btnSubmitLoading: false });
        return confirmDialog({
          message: t('La operación se ha realizado de manera éxitosa'),
          header: t('Confirmación'),
          icon: 'pi pi-check-circle',
          acceptLabel: t('Continuar'),
          rejectClassName: 'hide-component',
          accept: () => history.push('/emails'),
          onHide: () => history.push('/emails')
        });
      }
      this.setState({ btnSubmitLoading: false });
  }

  render() {
    const { loadingPage, btnSubmitLoading } = this.state;
    const { t } = this.props;

    if (loadingPage) return <LoadingAction/>

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t("Datos del Email")} linkText={t("Ir al listado")} to="/emails" />
          <div className="card">
            <div className="p-grid p-mb-2">
              <div className="p-col-12 p-my-1">
                <GeneralForm
                  success={this.newEmail}
                  btnSubmitLoading={btnSubmitLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  _general: state.email.general
});

const mapDispatchToProps = {
  addEmail,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(NewEmail);
